import { render } from "./ImageBig.vue?vue&type=template&id=71a524e0"
import script from "./ImageBig.vue?vue&type=script&lang=js"
export * from "./ImageBig.vue?vue&type=script&lang=js"

import "./ImageBig.vue?vue&type=style&index=0&id=71a524e0&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__